import { createContext, useContext, type RefObject } from "react";

const MainContentRefContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null);

export const useMainContentRef = (): RefObject<HTMLDivElement | null> => {
  const ref = useContext(MainContentRefContext);
  if (!ref) throw new Error("useMainContentRef must be used within AppLayout");
  return ref;
};

export default MainContentRefContext;
